import { FileText, Users, Link as LinkIcon, Eye } from 'lucide-react';

const stats = [
  {
    name: '内容统计',
    value: '0',
    description: '总内容数量',
    icon: FileText,
  },
  {
    name: '用户数量',
    value: '0',
    description: '注册用户总数',
    icon: Users,
  },
  {
    name: '导航链接',
    value: '0',
    description: '有效链接数量',
    icon: LinkIcon,
  },
  {
    name: '今日访问',
    value: '0',
    description: '今日访问量',
    icon: Eye,
  },
];

const systemStatus = [
  { label: '系统运行时间', value: '0天' },
  { label: 'CPU使用率', value: '0%' },
  { label: '内存使用率', value: '0%' },
  { label: '存储空间', value: '0GB/100GB' },
];

export default function Dashboard() {
  return (
    <div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
        {stats.map((stat) => (
          <div
            key={stat.name}
            className="bg-white p-6 rounded-lg shadow-sm"
          >
            <div className="flex items-center">
              <div className="flex-shrink-0">
                <stat.icon className="h-6 w-6 text-gray-400" />
              </div>
              <div className="ml-4">
                <h3 className="text-sm font-medium text-gray-900">{stat.name}</h3>
                <p className="text-2xl font-semibold text-gray-900">{stat.value}</p>
                <p className="text-sm text-gray-500">{stat.description}</p>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="bg-white p-6 rounded-lg shadow-sm">
          <h3 className="text-lg font-medium text-gray-900 mb-4">最近发布</h3>
          <div className="text-sm text-gray-500">暂无内容</div>
        </div>

        <div className="bg-white p-6 rounded-lg shadow-sm">
          <h3 className="text-lg font-medium text-gray-900 mb-4">系统状态</h3>
          <div className="space-y-4">
            {systemStatus.map((item) => (
              <div key={item.label} className="flex justify-between">
                <span className="text-sm text-gray-500">{item.label}</span>
                <span className="text-sm font-medium text-gray-900">{item.value}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}